var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',[_c('div',{staticClass:"banner-container"},[_c('div',{staticClass:"banner-text"},[_vm._v(" "+_vm._s(_vm.content)+" "),_c('a',{staticClass:"banner-link",attrs:{"href":_vm.link}},[_vm._v(_vm._s(_vm.linkTitle))])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }